module.exports = __webpack_public_path__ + "images/halloween_lp/step2-NumberIcon_77fb6bb57d49e6bcbe50418658819b70.png";